import { AppRouteProps } from "@harea/component";
import React from "react";

const AdminEmployeeImportContainer = React.lazy(
    () => import("./container/AdminEmployeeImportContainer")
);

export const AdminEmployeeImportRoutes: Array<AppRouteProps> = [
    {
        path: "import",
        title: "Harea.Admin.Employee.Import.Title",
        element: <AdminEmployeeImportContainer />,
        roles: ["DASHBOARD_ADMIN_RH", "DASHBOARD_MANAGER"],
    },
];